import { useEffect, useState } from "react";
import api from "@/lib/api";

let cached = null;

export function fetchBranding() {
  if (!cached) {
    cached = api.get("/website/sections/branding").then((r) => r.data).catch(() => null);
  }
  return cached;
}

export default function BrandLogo({ className = "h-9 w-auto", light = false }) {
  const [brand, setBrand] = useState(null);
  useEffect(() => { fetchBranding().then(setBrand); }, []);
  const src = brand?.logo_url || "/training-basket-logo.png";
  const img = <img src={src} alt={brand?.site_name || "Training Basket"} className={className} data-testid="brand-logo" />;
  if (light) return <span className="bg-white rounded-lg px-3 py-1.5 inline-flex">{img}</span>;
  return img;
}
